import React, { FC } from 'react';
import { Outlet, ScrollRestoration } from 'react-router-dom';
import GlobalFooter from './GlobalFooter';
import './Layout.scss';
import BasicNavigation from './BasicNavigation';

type BasicLayoutProps = { children?: JSX.Element };

const BasicLayout: FC<BasicLayoutProps> = () => (
    <>
        <BasicNavigation />
        <main
            role="main"
            className="flex-grow-1 ap-container page-container mt-4"
        >
            <Outlet />
        </main>
        <GlobalFooter />
        <ScrollRestoration />
    </>
);

export default BasicLayout;
